import * as React from "react";
import { Currency } from "swan-public-api-client";
import { useSelector } from "react-redux";
import { AppState } from "../Store/RootReducer";
import { TradeHistory } from "./TradeHistory";

interface PropsFromAppState {
  activeTradingAccountKey: string;
  activeTradingAccountCurrencies: Map<number, Currency>;
  baseCurrency: Currency
}

export function ActiveTradingAccountTradeHistory() {
  const {
    activeTradingAccountKey,
    activeTradingAccountCurrencies,
    baseCurrency
  } = useSelector<AppState, PropsFromAppState>(x => ({
    activeTradingAccountKey: x.activeTradingAccount.account!.Key,
    activeTradingAccountCurrencies: new Map<number, Currency>(
      x.activeTradingAccount.account!.Currencies.map(y => [parseInt(y.Key, 10), y])
    ),
    baseCurrency: x.clientAccount.account!.Currency
  }));

  return (
    <TradeHistory
      tradingAccountKey={activeTradingAccountKey}
      currencies={activeTradingAccountCurrencies}
      baseCurrency={baseCurrency}
    />
  );
}
